import React from 'react';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ChevronUpRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faChevronUp} {...props} />;
}
